import React from 'react'

const ManGoodbye = ({ style = {} }: { style?: React.CSSProperties }) => {
  return (
    <svg
      width='242'
      height='299'
      viewBox='0 0 242 299'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
    >
      <g clipPath='url(#clip0_1062_15584)'>
        <path
          d='M185.629 404.332L191.635 315.178L185.522 259.295C185.522 259.295 134.52 266.222 72.1079 251.138L70.4761 329.861L74.1544 376.049C104.09 386.212 132.942 399.759 165.284 403.129C172.053 403.837 178.848 404.225 185.629 404.332Z'
          fill='#414042'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M185.522 259.295C185.522 259.295 134.52 266.235 72.1079 251.138L71.9207 260.351C77.0436 264.122 90.4061 271.624 119.031 275.195C148.859 278.926 175.597 272.721 186.659 269.552L185.522 259.295Z'
          fill='#949191'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M151.882 275.783C154.182 275.596 156.43 275.369 158.596 275.115V262.959V260.86C141.021 261.06 116.168 259.95 88.0787 254.588L89.6437 259.295V268.896C91.4227 269.485 93.3488 270.073 95.4087 270.648L95.7565 259.696L152.47 264.189L151.882 275.783Z'
          fill='#414042'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M108.958 273.684C112.088 274.245 115.432 274.753 119.031 275.195C123.217 275.716 127.337 276.037 131.377 276.211L131.684 267.452L109.654 263.788L108.958 273.684Z'
          fill='white'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M94.138 272.347C94.138 272.347 85.5641 289.076 74.5557 291.108'
          stroke='#949191'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M155.734 280.103C155.734 280.103 157.032 290.466 163.546 299.011'
          stroke='#949191'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M114.202 292.365L115.352 321.704L123.913 328.23L123.097 297.634'
          stroke='#949191'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M113.72 280.103L113.921 285.371'
          stroke='#949191'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M132.928 98.9995C132.928 98.9995 86.594 100.444 83.3303 102.623C80.0666 104.79 52.9269 118.189 52.9269 118.189C52.9269 118.189 62.3435 99.3739 62.3435 91.765C62.3435 84.1695 56.5518 79.4624 46.0517 75.4774C35.5516 71.4924 21.0789 77.2827 18.1763 85.2526C15.2737 93.2092 1.5233 142.433 0.0787067 156.554C-1.36589 170.676 17.454 182.978 25.4127 182.256C33.3713 181.534 73.9271 166.691 73.9271 166.691C73.9271 166.691 71.0245 246.31 71.0245 248.49C71.0245 250.656 71.0245 253.919 75.3717 255.724C79.7188 257.529 100.344 268.027 125.331 270.207C150.303 272.373 178.54 267.305 182.165 266.944C185.79 266.583 189.04 258.987 189.04 255.724C189.04 252.461 191.943 227.495 191.943 227.495L197.373 249.573C197.373 249.573 200.998 253.558 212.582 254.641C224.165 255.724 233.221 249.934 235.749 244.144C238.277 238.353 238.277 236.909 238.277 236.909C238.277 236.909 214.749 147.154 212.943 139.197C211.137 131.24 211.498 131.24 206.429 125.45C201.359 119.66 168.414 106.635 159.372 104.094C150.33 101.554 132.928 98.9995 132.928 98.9995Z'
          fill='#EBD9D9'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M52.9269 118.176L37.7319 160.526'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M46.774 136.282C46.774 136.282 47.4963 147.141 46.0517 156.916'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M73.9271 166.677L75.0105 127.229'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M73.927 159.803C73.927 159.803 67.7741 144.96 66.6907 131.574'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M191.943 227.482L204.115 155.164'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M196.704 200.015L207.86 165.461'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M125.959 129.181L131.671 142.647L104.331 235.238L118.201 256.032L134.935 236.455L137.784 144.68L154.918 134.891L141.462 116.945L125.959 129.181Z'
          fill='#414042'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M133.704 92.0723C133.704 92.0723 127.177 93.3025 126.762 95.7497C126.361 98.1968 120.649 102.677 119.419 112.064C118.188 121.451 119.833 134.503 119.833 134.503C119.833 134.503 132.487 128.793 134.935 128.392C137.382 127.977 144.324 128.806 145.542 130.839C146.772 132.872 153.3 145.522 156.563 143.489C159.827 141.443 175.33 124.313 176.146 110.446C176.962 96.5788 163.492 97.7957 161.86 96.9799C160.228 96.1509 133.704 92.0723 133.704 92.0723Z'
          fill='#EBD9D9'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M133.704 79.0205C133.704 79.0205 132.473 90.8551 131.657 100.644C130.842 110.432 129.611 120.635 133.704 125.931C137.784 131.24 142.278 132.056 152.069 124.701C161.86 117.359 167.572 110.833 169.204 103.893C170.835 96.9663 173.283 89.6115 173.283 89.6115C173.283 89.6115 153.286 94.9203 133.704 79.0205Z'
          fill='white'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M133.704 79.0205C133.704 79.0205 132.674 89.0231 131.872 98.25C134.56 101.112 138.065 103.358 142.76 104.334C155.948 107.116 167.866 97.1936 172.708 91.4167C173.069 90.2935 173.283 89.6248 173.283 89.6248C173.283 89.6248 153.286 94.9203 133.704 79.0205Z'
          fill='#414042'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M133.142 48.9595C133.142 48.9595 131.51 43.6507 128.247 47.7293C124.983 51.8079 126.615 62.011 128.661 64.4582C130.694 66.9053 133.142 48.9595 133.142 48.9595Z'
          fill='white'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M138.88 23.9931C138.88 23.9931 126.361 64.9662 128.26 73.685C130.159 82.4038 133.57 97.2071 147.989 100.243C162.409 103.278 175.303 91.136 179.102 85.8272C179.102 85.8272 188.973 86.9638 191.622 80.5183C194.283 74.0728 198.069 67.2395 194.283 65.7284C190.485 64.2173 188.973 64.2173 188.973 64.2173C188.973 64.2173 199.594 47.5286 200.356 41.8319C201.119 36.1486 197.32 17.1732 185.174 8.06655C173.029 -1.04007 152.537 -2.17673 153.688 1.99547C154.825 6.16766 157.486 6.54209 157.486 6.54209C157.486 6.54209 133.584 3.88098 131.684 10.3399C129.785 16.7854 140.031 20.5831 140.031 20.5831L138.88 23.9931Z'
          fill='white'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M188.96 64.191C188.96 64.191 199.58 47.5022 200.343 41.8055C201.105 36.1223 197.306 17.1468 185.161 8.04018C173.016 -1.06644 152.524 -2.20309 153.674 1.9691C154.811 6.1413 157.473 6.51572 157.473 6.51572C157.473 6.51572 133.57 3.85461 131.671 10.3135C129.772 16.759 140.017 20.5568 140.017 20.5568L138.88 23.9667C138.88 23.9667 136.486 31.8163 133.945 41.3776L134.707 41.4177C134.707 41.4177 135.844 38.0078 137.369 32.6989C138.88 27.3901 141.917 21.319 157.098 22.8301C172.28 24.3412 187.448 32.3111 188.211 38.0078C188.973 43.691 182.513 45.9777 184.8 48.6255C187.074 51.2866 190.11 52.4232 188.211 54.3221C186.311 56.221 182.513 64.191 184.8 65.3276C187.074 66.4643 190.873 64.5654 190.873 64.5654C190.873 64.5654 190.913 64.5654 190.98 64.5654C189.575 64.2043 188.96 64.191 188.96 64.191Z'
          fill='#414042'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M152.537 50.5381L145.716 68.7513L152.925 71.0246'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M147.227 76.7074C147.227 76.7074 155.574 81.254 163.546 73.6719'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M138.88 40.6826C138.88 40.6826 148.364 42.1937 151.026 43.7182'
          stroke='#414042'
          stroke-width='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M164.683 44.0926C164.683 44.0926 171.518 41.8193 176.066 47.5026'
          stroke='#414042'
          stroke-width='2'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M144.552 50.3907C144.338 52.0488 143.402 53.2925 142.465 53.1721C141.529 53.0518 140.954 51.6076 141.168 49.936C141.382 48.2778 142.318 47.0342 143.254 47.1545C144.204 47.2749 144.779 48.7191 144.552 50.3907Z'
          fill='#414042'
        />
        <path
          d='M166.582 56.6358C166.368 58.294 165.432 59.5376 164.495 59.4172C163.559 59.2969 162.984 57.8527 163.198 56.1811C163.412 54.5229 164.348 53.2793 165.284 53.3996C166.221 53.5334 166.796 54.9776 166.582 56.6358Z'
          fill='#414042'
        />
        <path
          d='M68.3493 32.6446C65.9952 32.0295 63.7614 35.7336 63.213 36.6965L60.6047 42.567L59.4142 20.1815C59.3607 19.2588 58.9461 18.4565 58.3308 17.8815C57.7021 17.3198 56.8728 16.9855 55.9766 17.039C54.2244 17.1326 52.8734 18.6437 52.9135 20.4356L52.7263 16.9454C52.6326 15.1535 51.1078 13.7761 49.3154 13.8697C47.523 13.9633 46.1453 15.4878 46.239 17.2797L46.3727 19.8472C46.2791 18.0553 44.7542 16.6779 42.9619 16.7716C41.1695 16.8652 39.8587 18.4164 39.9523 20.2083L40.4739 29.9701C40.2733 28.2852 38.8153 27.0282 37.13 27.1218C35.3644 27.2154 34.0669 28.7666 34.1605 30.5585L34.8694 43.9309L35.5249 56.3004C35.6185 57.9452 35.9796 59.4697 36.4077 60.7534C37.5981 64.3506 38.2803 66.8379 38.6281 70.181C38.7618 71.4113 38.7752 72.6683 38.7083 73.9119V73.9386C38.6548 75.0218 39.2567 76.0381 40.3134 76.5596C42.0256 77.4021 45.1689 78.3783 50.2785 78.0841C55.6823 77.7765 58.5314 76.212 59.9091 75.0753C60.6314 74.4869 61.0193 73.6444 60.9658 72.7752V72.7619C61.113 70.7025 61.0595 66.41 63.9085 63.0936C66.9181 59.4296 66.0219 50.4299 66.5703 47.702L70.5296 37.0575C71.1048 35.4528 70.9041 33.3132 68.3493 32.6446Z'
          fill='white'
        />
        <path
          d='M60.2168 20.1418L61.2333 39.1975L62.4773 36.3893C62.4907 36.3625 62.504 36.3358 62.5174 36.309C63.641 34.3566 65.9283 31.1874 68.5633 31.8694C70.1015 32.2706 70.8372 33.1264 71.1716 33.7816C71.6933 34.7712 71.7468 36.0817 71.292 37.3521L67.3461 47.943C67.2123 48.6651 67.1722 49.9221 67.1321 51.3664C67.0117 55.3513 66.8512 60.8073 64.5238 63.6289C62.1161 66.4371 61.9289 70.0209 61.8085 72.1739C61.7951 72.4012 61.7817 72.6018 61.7684 72.8024C61.8219 73.9256 61.327 74.9821 60.4174 75.7309C58.8658 77.0147 55.8562 78.606 50.3186 78.9136C50.2785 78.9136 50.2383 78.9136 50.1848 78.9269C44.995 79.2077 41.758 78.2048 39.9389 77.3089C38.6147 76.667 37.8121 75.3431 37.879 73.9256C37.879 73.9123 37.879 73.8588 37.879 73.8454C37.9459 72.6553 37.9191 71.4517 37.7987 70.2883C37.4644 67.0388 36.8089 64.6184 35.6185 61.0346C35.0968 59.4701 34.7892 57.8921 34.6955 56.3677L33.3178 30.6257C33.1974 28.3792 34.8694 26.4669 37.0497 26.3466C37.9459 26.2931 38.7886 26.5472 39.4707 27.0152L39.1096 20.2755C38.9892 18.0289 40.6879 16.1167 42.8816 15.9963C43.8179 15.9428 44.7007 16.2236 45.4096 16.7184C45.6103 14.7661 47.2154 13.1881 49.2218 13.0811C51.4555 12.9608 53.3683 14.6858 53.4887 16.919L53.5021 17.1998C54.1441 16.6516 54.9734 16.3039 55.883 16.2504C56.9397 16.1835 58.0097 16.558 58.8257 17.3068C58.8658 17.2801 60.1098 18.2563 60.2168 20.1418ZM37.1701 27.9379C35.8592 28.0047 34.8962 29.1414 34.9631 30.5188L36.3408 56.2607C36.421 57.638 36.7019 59.0689 37.1835 60.5131C38.4007 64.2173 39.0828 66.7179 39.4306 70.1145C39.5644 71.3581 39.5911 72.6553 39.5109 73.9658C39.5109 73.9791 39.5109 74.0192 39.4975 74.0326C39.4574 74.7681 39.8988 75.4768 40.6612 75.8379C42.3064 76.6402 45.2625 77.5496 50.1046 77.2955C50.1447 77.2955 50.1848 77.2955 50.225 77.2955C55.5887 76.9879 58.2639 75.3966 59.3875 74.4739C59.9091 74.046 60.19 73.4576 60.1499 72.8425C60.1499 72.8024 60.1499 72.7622 60.1499 72.7221C60.1633 72.5215 60.1766 72.3076 60.19 72.0669C60.3238 69.7133 60.5378 65.7818 63.2798 62.5725C65.2461 60.1922 65.3932 55.0572 65.5136 51.2995C65.5671 49.6814 65.5939 48.3977 65.7678 47.5419C65.7811 47.5017 65.7945 47.4616 65.8079 47.4215L69.7672 36.7771C70.0614 35.948 70.0614 35.1189 69.7404 34.5171C69.4595 33.9822 68.9245 33.6078 68.1487 33.4072C66.7977 33.0462 65.0856 35.052 63.9219 37.0445L58.9594 48.2105C58.8524 48.4378 58.6518 48.6116 58.411 48.6651C58.1034 48.7454 50.7065 50.6977 51.3753 63.201C51.402 63.6422 51.0543 64.03 50.6129 64.0434C50.1715 64.0702 49.7836 63.7225 49.7702 63.2812C49.1148 50.9117 55.883 47.8093 57.6486 47.2075L59.7887 42.3935L58.6116 20.1819C58.5715 19.5133 58.2773 18.8848 57.7823 18.4301C57.3008 17.9888 56.6721 17.7615 56.0301 17.8016C56.0301 17.8016 56.0301 17.8016 56.0167 17.8016C54.7059 17.8818 53.6893 19.0051 53.7161 20.3691L54.9065 42.8348C54.9333 43.2761 54.5855 43.6639 54.1441 43.6772C53.7027 43.704 53.3148 43.3563 53.3014 42.915L51.9237 16.9458C51.8568 15.5951 50.7065 14.5655 49.3555 14.6323C48.0046 14.6992 46.9746 15.8492 47.0415 17.1998L48.4192 43.1691C48.446 43.6104 48.0982 43.9982 47.6568 44.0115C47.2154 44.0383 46.8275 43.6906 46.8141 43.2493L45.5701 19.8476C45.5033 18.497 44.3529 17.4673 43.002 17.5341C41.6644 17.601 40.6746 18.7377 40.7548 20.115L41.2631 29.7967C41.2765 29.8903 41.2899 29.9972 41.2899 30.1042L41.9988 43.5034C42.0255 43.9447 41.6778 44.3325 41.2364 44.3458C40.7949 44.3726 40.407 44.0249 40.3937 43.5836L39.658 29.9571C39.4841 28.7804 38.414 27.871 37.1701 27.9379Z'
          fill='#414042'
        />
        <path
          d='M35.1904 79.8232C35.1904 79.8232 35.1904 85.6135 44.9682 87.4188C54.746 89.2241 57.9963 83.4338 57.9963 83.4338'
          fill='white'
        />
        <path
          d='M35.1904 79.8232C35.1904 79.8232 35.1904 85.6135 44.9682 87.4188C54.746 89.2241 57.9963 83.4338 57.9963 83.4338'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M57.9964 83.4331L61.3136 74.3399C47.9243 78.2847 41.758 74.6608 39.2032 71.9863L35.1771 79.8092C35.1771 79.8092 35.1771 85.5995 44.9548 87.4047C54.746 89.2234 57.9964 83.4331 57.9964 83.4331Z'
          fill='#EBD9D9'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M214.508 241.643C214.508 241.643 202.857 241.95 199.179 246.243C195.501 250.535 195.193 271.677 195.193 275.047C195.193 278.417 201.934 288.526 214.2 290.987C226.466 293.434 236.886 286.079 237.193 278.417C237.501 270.754 242.704 249.92 241.487 241.95C240.256 233.98 235.053 231.226 235.053 231.226'
          fill='#EBD9D9'
        />
        <path
          d='M214.508 241.643C214.508 241.643 202.857 241.95 199.179 246.243C195.501 250.535 195.193 271.677 195.193 275.047C195.193 278.417 201.934 288.526 214.2 290.987C226.466 293.434 236.886 286.079 237.193 278.417C237.501 270.754 242.704 249.92 241.487 241.95C240.256 233.98 235.053 231.226 235.053 231.226'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M213.09 292.137C221.053 292.137 227.509 285.833 227.509 278.056C227.509 270.279 221.053 263.975 213.09 263.975C205.126 263.975 198.671 270.279 198.671 278.056C198.671 285.833 205.126 292.137 213.09 292.137Z'
          fill='#EBD9D9'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M217.263 290.973C217.263 290.973 218.801 284.234 217.263 280.249C215.725 276.264 205.613 271.062 202.55 272.279C199.487 273.509 201.011 275.649 198.256 276.879C195.501 278.109 185.081 279.634 182.927 282.388C180.787 285.143 179.249 290.358 175.878 296.483C172.507 302.607 168.521 305.376 173.123 305.67C177.724 305.977 181.095 302.915 182.62 299.853C184.158 296.79 187.221 295.253 187.221 295.253C187.221 295.253 178.941 313.947 180.172 315.779C181.402 317.611 182.62 317.919 182.62 317.919C182.62 317.919 181.697 321.596 183.85 322.519C185.99 323.442 187.836 322.211 187.836 322.211C187.836 322.211 190.592 324.351 192.13 324.351C193.668 324.351 194.885 323.428 194.885 323.428C194.885 323.428 200.102 324.043 201.627 321.596C203.165 319.149 209.906 311.179 213.277 304.747C216.648 298.315 217.263 290.973 217.263 290.973Z'
          fill='white'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M182.62 317.945L195.808 298.328'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M187.221 295.266L189.682 286.988'
          stroke='#414042'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_1062_15584'>
          <rect width='242' height='299' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ManGoodbye
